/**
 * The project a URL belongs to, so a bookmarked or shared project page opens on
 * its own project instead of bouncing to the Context Selector.
 *
 * Project pages read `selectedProject` from the store, which only lives in
 * localStorage. A bookmark opened in a browser with no saved project (or a
 * different one) used to land on "/". The shell now stamps `?project=<id>` on
 * every project-only page (AppShell), and ProtectedRoute restores the project
 * from it. `/projects/:id` pages already carry the id in the path.
 */
export const PROJECT_URL_PARAM = 'project'

export function projectIdFromUrl(pathname: string, search: string): string | null {
  const fromParam = new URLSearchParams(search).get(PROJECT_URL_PARAM)
  if (fromParam) return fromParam
  const m = /^\/projects\/([^/]+)/.exec(pathname)
  const segment = m?.[1]
  if (segment && segment !== 'new') return decodeURIComponent(segment)
  return null
}

/** `search` with `project` set to `projectId`, or null when it already is. */
export function withProjectParam(search: string, projectId: string): string | null {
  const params = new URLSearchParams(search)
  if (params.get(PROJECT_URL_PARAM) === projectId) return null
  params.set(PROJECT_URL_PARAM, projectId)
  return `?${params.toString()}`
}
